import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LaunchDialogService } from '@spartacus/storefront';
import { RmaService } from '../../../../rma/rma-services/rma.service';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { response } from 'express';
import { Observable, take } from 'rxjs';

@Component({
  selector: 'app-waygate-rma-contact-details-modal',
  standalone: false,
  templateUrl: './waygate-rma-contact-details-modal.component.html',
  styleUrl: './waygate-rma-contact-details-modal.component.scss',
})
export class WaygateRmaContactDetailsModalComponent implements OnInit {
  contactForm!: FormGroup;
  rmaCartId$: Observable<string> = this.activecartfacade.getActiveCartId();
  rmaCartId: string;
  constructor(
    private fb: FormBuilder,
    private activecartfacade: ActiveCartFacade,
    private rmaService: RmaService,
    private launchDialogService: LaunchDialogService
  ) {}

  ngOnInit(): void {
    this.contactForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      emailId: ['', [Validators.required, Validators.email]],
      contactNumber: ['', Validators.required],
      termsAccepted: [false, Validators.requiredTrue],
    });
  }

  closeModal(): void {
    this.launchDialogService.closeDialog('closed');
  }

  submit(): void {
    if (this.contactForm.invalid) {
      this.contactForm.markAllAsTouched();
      return;
    }
    const { termsAccepted, ...payload } = this.contactForm.getRawValue();
    this.rmaCartId$.subscribe((rmaCartId) => {
      this.rmaCartId = rmaCartId;
      console.log('rmacartid', rmaCartId);
    });
    if (!this.rmaCartId) {
      console.error('RMA cart ID is missing');
      return;
    }
    // const payload = this.contactForm.getRawValue();

    this.rmaService
      .saveGuestDetails(this.rmaCartId, payload)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          sessionStorage.setItem('guestContactSubmitted', 'true');
          console.log('Contact details saved successfully:', response);
          this.launchDialogService.closeDialog('submitRMAFILLED');
        },
        error: (error) => {
          console.error('Error saving contact details:', error);
        },
      });
  }
}
